import API_USER from '@/api/user'

import { getToken, setToken, removeToken } from '@/utils/auth'
import router, { resetRouter } from '@/router'
import {tipmessage} from "../../utils";

const state = {
  //用户token
  token: getToken(),
  //登录者用户名
  username: '',
  //客户等级
  level: -1,
  //登录的用户所属的客户ID
  customid: null,
  //是否已登录
  isLogin: false,
  //该客户下所有的子客户列表
  customList: [],
  //计费组
  setmealList: [],
  //email
  email: "",
  //phone
  phone: "",
  //企业名称
  cpy_name: "",
  //用户备注
  remark: "",
  //上次登录的时间
  lastlogin: ""
}

const mutations = {
  SET_CUSTOMLIST: (state,arr) => {
    state.customList = arr;
  },

  SET_BILLS : (state,arr) => {
    state.setmealList = arr;
  },

  SET_LEVEL: (state,level) => {
    state.level = level;
  },

  SET_TOKEN: (state, token) => {
    state.token = token
  },

  SET_NAME: (state, name) => {
    state.username = name
  },

  SET_CUSTOMID: (state,customid) => {
    state.customid = customid
  },
  SET_EMAIL: (state,email) => {
    state.email = email;
  },
  SET_PHONE: (state,phone) => {
    state.phone = phone;
  },
  SET_CUSTOMNAME: (state,cpyname) => {
    state.cpy_name = cpyname;
  },
  SET_REMARK: (state,remark) => {
    state.remark = remark;
  },
  SET_LASTLOGIN: (state,time) => {
    state.lastlogin = time;
  },
  CHANGE_LOGIN_STATUE: (state) => {
    if(!state.isLogin){
      state.isLogin = true;
    }else {
      state.isLogin = false;
    }
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      API_USER.LOGIN(username.trim(),password).then((response) => {
          commit('SET_TOKEN', response.token);//保存token;
          setToken(response.token);
          resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      API_USER.GETINFO().then(response => {
        if (!response.auth_list) {
          reject('验证失败，请重新登录!')
        }
        commit("SET_NAME",response.username);//保存当前用户的用户名;
        commit("SET_CUSTOMNAME",response.cpy_name);//保存当前用户的企业名称;
        commit("SET_CUSTOMID",response.id);//保存当前用户的id;
        commit("SET_EMAIL",response.email);//保存当前用户邮件;
        commit("SET_PHONE",response.phone);//保存当前用户的联系方式;
        commit("SET_REMARK",response.remark);//保存当前用户的备注;
        commit("CHANGE_LOGIN_STATUE");//改变当前登录信息;
        commit("SET_LEVEL",response.cpy_level);//保存当前用户的客户等级;
        if(state.level == "1"){
          API_USER.FETCH_ALL_CUSTOM().then((res) => {
            commit("SET_CUSTOMLIST",res.result);
          },(error) => {
            commit("SET_CUSTOMLIST",[]);
          })
        }
        resolve(response.auth_list);
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      removeToken();
      commit("CHANGE_LOGIN_STATUE");
      resolve();
    })
  },
  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLE', null)
      removeToken()
      resolve()
    })
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js